import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/logo-monitur.svg'


const _withScopeId = n => (_pushScopeId("data-v-2d58ffc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Monitur Logo Footer",
  class: "logo-monitur"
}, null, -1))

import { editablesGetValueByPath } from "@/lib/i18n-helpers";

export default /*#__PURE__*/_defineComponent({
  __name: '_Footer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("nav", null, [
      _hoisted_1,
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, _toDisplayString(_unref(editablesGetValueByPath)("footer.economics")), 1),
        _createElementVNode("li", null, _toDisplayString(_unref(editablesGetValueByPath)("footer.local")), 1),
        _createElementVNode("li", null, _toDisplayString(_unref(editablesGetValueByPath)("footer.email")), 1),
        _createElementVNode("li", null, _toDisplayString(_unref(editablesGetValueByPath)("footer.phoneNumber")), 1)
      ])
    ])
  ]))
}
}

})